// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function company<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('company/list', data, options);
    case 'get':
      return id ? api.get(`company/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('company/set', data, options);
    case 'del':
      return id ? api.get(`company/del/${id}`, data, options) : undefined;
    case 'dashboard':
      return api.post('company/dashboard', data, options);
    case 'installers':
      return id ? api.get(`company/installers/${data.assigned}/${id}`, data, options) : undefined;
    case 'installer':
      return id ? api.get(`company/installer/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function client<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('client/list', data, options);
    case 'get':
      return id ? api.get(`client/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('client/set', data, options);
    case 'del':
      return id ? api.get(`client/del/${id}`, data, options) : undefined;
    case 'report':
      return id ? api.download(`client/report/${id}`, data, options) : undefined;
    case 'reports':
      return api.get('client/report/list', data, options);
    case 'sensor':
      return id ? api.get(`client/sensor/${id}`, data, options) : undefined;
    case 'sensors':
      return id ? api.get(`client/sensors/${data.assigned}/${id}`, data, options) : undefined;
    case 'dashboard':
      return api.post('client/dashboard', data, options);
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function installer<T>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('installer/list', data, options);
    case 'get':
      return id ? api.get(`installer/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('installer/set', data, options);
    case 'del':
      return id ? api.get(`installer/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function location<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('location/list', data, options);
    case 'get':
      return id ? api.get(`location/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('location/set', data, options);
    case 'del':
      return id ? api.get(`location/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function system<T = any>(action: string, id?: string, data = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'log-list':
      return api.get('system/log-list', data, options);
    case 'log-content':
      return id ? api.get(`system/log-content/${id}`, data, options) : undefined;
    case 'proc-list':
      return api.get('system/proc-list', data, options);
    default:
      return undefined;
  }
}
